<div class="filled-info">
  <app-peronal-info-edit></app-peronal-info-edit>
  <app-contact-info-edit></app-contact-info-edit>
  <app-period-edit *ngIf="once"></app-period-edit>
  <app-insurance-type-edit-multiple *ngIf="multiple"></app-insurance-type-edit-multiple>
  <app-insurance-type-edit></app-insurance-type-edit>
  <!-- სხვა მოგზაურობის ინფო  -->
  <div class="filled" *ngIf="once">
    <div class="row align-items-center filled-row justify-content-xs-center">
      <div class="col filled-title">
        სხვა მოგზაურების ინფო
      </div>
      <div class="col">
        <p *ngIf="user.PassengerInfo">
          <span class="d-block" *ngFor="let u of user.PassengerInfo">
            {{u.name}} {{u.surname}}
          </span>
        </p>
        <p *ngIf="!user.PassengerInfo?.length && !user.PassengerInfo">
          არ არის დამატებული
        </p>
      </div>
      <div class="col edit-btn">
        <button class="ml-m@s g-b--w0 g g--alignCenter g--nowrap cur-p edit ms-auto d-flex" (click)="edit()">
          <div class="mr-xs fz-12" style="color: #737373;">ცვლილება</div>
          <i class="fas fa-pen"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- სხვა მოგზაურობის ინფო  -->

<div class="form-group filled-info-terms">
  <mat-checkbox [formControl]="termsConditions" [ngClass]="{'has-mat-checkbox-error': !termsConditions.value}" class="terms">გავეცანი და ვეთანხმები
    <a href="https://aldagi.info/rtip-001-24-1-geo" target="_blank" download>სადაზღვევო პირობებს</a>
    <br>და პერსონალური მონაცემების <a href="assets/img/pdpr.pdf" target="_blank" download>დამუშავების წესებს</a></mat-checkbox>
</div>

<div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd">
  <app-prev-btn></app-prev-btn>
  <app-next-btn (click)="onSubmit()"></app-next-btn>
</div>
